<template>
    <div>

        <!-- Header -->
        <top-header v-if="modus==='orders'" title="BESTELLUNGEN" underline="Ihre Bestellungen in der Übersicht"> </top-header>

        <top-header v-if="modus==='wizard'" title="PROBLEM MELDEN" underline="Bitte folgen Sie unserem Assistenten"> </top-header>
        <!-- Header -->


        <!-- View that holds all orders from customer -->
        <div v-if="modus==='orders'" class="container">
            <div class="row mb-3">

                <order-card v-for="(order, index) in orders" :key="index" :order="order" colsize="12" v-on:openwizard="newWizzard"> </order-card>

            </div>
        </div>

        <!-- View that holds the problem wizard -->
        <div v-if="modus==='wizard'" class="container">
            <div class="row mb-1">

                <wizard :order-id="currentOrderId" v-on:abbort="modus='orders'"> </wizard>

            </div>
        </div>

    </div>
</template>

<script>

    import OrderCard from '../components/OrderCard'
    import TopHeader from '../components/Header'
    import Wizard from '../components/wizard/ProblemWizard'

    export default {
        name: "dashboard",

        components: {
            OrderCard,
            TopHeader,
            Wizard
        },

        data() {
            return {
                triggerrefresh: false,
                modus: 'orders',
                currentOrderId: false
            }
        },

        props: [],

        computed: {

            orders: function () {
                return this.$store.getters.getOrders.filter(x => x.statusId <= 7)
            }
        },

        methods: {
            loadOrders: function () {

                this.$swal({
                    text: 'Aufträge werden geladen..',
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    buttons: false,
                })

                this.$RestClient.loadOrders( this.$store.getters.getUserData.id)
                    .then(data => this.$store.commit('setOrders', data))
                    .then(() => this.$swal.close())
            },

            newWizzard: function (orderId) {

                this.currentOrderId = orderId

                this.$swal({
                    text: 'Assistent wird geladen..',
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    buttons: false,
                })

                setTimeout(() => {
                    this.$swal.close()
                    this.modus = 'wizard'
                },1000 )
            }
        },

        mounted() {
            this.loadOrders()
        },

        watch: {
        }
    }
</script>

<style scoped>

</style>